<template>
    <div class="n2-center-container">
        <div id="n3-cancellation" class="n2-padding">
            <div>
                <app-content name="web.term.change"></app-content>
            </div>
            <div v-if="change_step == 1">
                <div>
                    <div v-for="(pline, index) in product_lines" v-bind:key="pline"
                        style="border: 1px solid #cccccc; padding: 10px; margin-top: 10px;">
                        <div>
                            <div style="">
                                <div>
                                    <div class="product">
                                        <div class="quanitity-selector">
                                            <div class="quanity-btn" v-bind:class="{ disabled: pline.quantity <= 0 }"
                                                v-on:click="changeQuantity(pline, -1)">
                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                            </div>
                                            <input class="product-quantity-field" type="text"
                                                autocomplete="one-time-code" v-model="pline.quantity" />
                                            <div class="quanity-btn"
                                                v-bind:class="{ disabled: pline.quantity >= entity.product_lines[index].quantity }"
                                                v-on:click="changeQuantity(pline, 1)">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                        <div class="product-name">
                                            <span>{{ pline.title }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="text-align: right;">
                    <button style="margin: 20px 0 0 0;" v-on:click="changePassengerNextStep()" class="n2-button-1">{{
                        $t('pages.change.next_step') }}</button>
                </div>
            </div>
            <div v-if="change_step == 2">
                <shopping-cart></shopping-cart>
                <div v-if="vehicles.length > 0">
                    <h5>{{ $t('pages.checkout.vehicles') }}</h5>
                    <div>
                        <app-content name="web.checkout.vehicle_field_description"></app-content>
                    </div>
                    <div v-for="(v, index) in vehicles" v-bind:key="v"
                        style="border: 1px solid #cccccc; padding: 10px; margin-top: 10px;">
                        <div>
                            <div class="n2-form-group">
                                <label class="n2-form-label">{{ $t('pages.checkout.vehicle') }} {{ index + 1 }}:
                                    {{ getProductName(v.product_id) }}</label>
                            </div>

                        </div>
                        <div>
                            <form-input type="text" v-model="v.model"
                                v-bind:placeholder="$t('pages.checkout.required_field')"
                                v-bind:label="$t('pages.checkout.make_and_model')"
                                v-bind:errors="v.model_errors"></form-input>
                        </div>
                        <div>
                            <form-input type="text" v-model="v.registration_number"
                                v-bind:placeholder="$t('pages.checkout.required_field')"
                                v-bind:label="$t('pages.checkout.registration_number')"
                                v-bind:errors="v.registration_number_errors"></form-input>
                        </div>
                    </div>

                </div>
                <div>
                    <form-input type="checkbox" v-model="agree_term">
                        <template v-slot:inline>
                            {{ $t('pages.change.read_term') }}
                            {{ $t('pages.change.term_change') }}
                        </template>
                    </form-input>
                </div>
                <div v-if="shopping_cart.outstanding_amount > 0">
                    <p style="font-size: 18px;">{{ $t('pages.change.payment_desc') }}</p>
                    <p style="font-size: 18px; font-weight: bold;">
                        {{ $t('pages.change.payment_amount') }}: <span style="font-size: 22px;">{{
                            parseFloat(shopping_cart.outstanding_amount).toFixed(2) }} {{ $t('pages.change.currency_nok')
                            }}</span>
                    </p>
                </div>
                <div style="padding: 10px 0;">
                    <validation-summary v-bind:errors="vehicle_errors"></validation-summary>
                    <result-summary v-bind:error="result_error"></result-summary>
                </div>
                <div v-if="shopping_cart.outstanding_amount > 0">

                    <div class="n2-gateways n2-clear">
                        <div v-on:click="nextStep('vipps')" class="n2-left">
                            <img class="n2-btn-payment" v-if="app_locale == 'no'"
                                src="../assets/images/vipps/pay_with_vipps_rect_210_NO.svg" />
                            <img class="n2-btn-payment" v-else
                                src="../assets/images/vipps/pay_with_vipps_rect_210_EN.svg" />
                        </div>
                        <div class="n2-left">
                            <button v-on:click="nextStep('nets')"
                                class="n2-btn-payment n2-btn-payment n2-btn-payment-local">
                                {{ $t('pages.checkout.pay_with_card') }}</button>
                        </div>
                    </div>
                </div>
                <div style="display: flex; justify-content: space-between;">

                    <div>
                        <button style="margin: 20px 0 0 0;" v-on:click="goPreviousStep" class="n2-button-1">{{
                            $t('pages.change.previous_step') }}</button>
                    </div>
                    <div v-if="shopping_cart.outstanding_amount <= 0">
                        <button style="margin: 20px 0 0 0;" v-on:click="changePassengers" class="n2-button-1">{{
                            $t('pages.change.confirm_change') }}</button>
                    </div>
                </div>
            </div>
            <div v-if="change_step == 3">
                <h4 v-if="success">
                    {{ $t('pages.change.change_success') }}
                </h4>
                <h4 v-else style="color: #fff;">
                    {{ $t('pages.change.change_faile') }}
                </h4>

                <div style="background:#fff; padding:20px;">
                    <div v-html="order_html"></div>
                </div>
            </div>
        </div>

        <app-loader v-bind:active="loading"></app-loader>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { OrderService, CheckoutService, EmailService, ShoppingCartService } from '../services'
import AppLoader from '../components/shared/loader.vue'
import FormInput from "../components/shared/form-input.vue"
import ValidationSummary from '../components/shared/validation-summary.vue';
import AppContent from '../components/shared/content.vue';
import ResultSummary from '../components/shared/result-summary.vue';
import ShoppingCart from '../components/app/shopping-cart.vue'


export default {
    components: {
        AppLoader, FormInput, ValidationSummary, AppContent, ResultSummary, ShoppingCart
    },

    data: function () {
        return {
            vehicle_errors: {},
            change_step: 1,
            product_lines: [],
            vehicles: [],
            entity: {
                contact: {
                    address: {}
                },
                vehicles: [],
                product_lines: []
            },
            success: false,
            loading: false,
            result_error: '',
            model_errors: {},
            order_html: '',
            agree_term: false
        }
    },
    computed: {
        ...mapGetters('globalization', [
            'app_locale',
            'locale',
        ]),
        ...mapGetters('identity', [
            'user'
        ]),
        ...mapGetters('shopping_cart_store', [
            'shopping_cart'
        ]),
    },
    created: function () {
        this.orderService = new OrderService()
        this.checkoutService = new CheckoutService()
        this.emailService = new EmailService()
        this.shoppingCartService = new ShoppingCartService()
    },
    mounted: async function () {
        await this.findBooking(this.$route.query);
    },
    methods: {
        validateForm: function () {
            this.model_errors = {}


            //////////////////
            if (Object.keys(this.model_errors).length > 0) {
                return false
            }
            else {
                return true
            }
        },
        findBooking: async function (query) {
            let model = { booking_number: query.booking_number, email: query.email };
            this.result_error = '';

            this.loading = true
            try {
                let o = await this.orderService.findAnonymous(model)
                this.entity = o;
                this.product_lines = [];
                this.vehicles = [];
                this.entity.product_lines.forEach((pl) => {
                    let newPl = {};
                    Object.assign(newPl, pl);
                    this.product_lines.push(newPl);
                });
                this.entity.vehicles.forEach((pl) => {
                    let newPl = {};
                    Object.assign(newPl, pl);
                    this.vehicles.push(newPl);
                });
            }
            catch {
                this.result_error = this.$t('pages.change.error_order_not_found')
            }
            finally {
                this.loading = false;
            }
        },
        getProductName: function (product_id) {
            return this.entity.product_lines.find(p => p.product_id == product_id).title;
        },
        changeQuantity: async function (pline, amount) {
            let quantity = this.entity.product_lines.find(p => p.product_id == pline.product_id).quantity;
            if (amount > 0) {
                let isMax = pline.quantity >= quantity;
                if (isMax) {
                    return;
                }
            }
            else {
                if (pline.quantity <= 0) {
                    return;
                }
                if (pline.quantity <= 1) {
                    if (!this.product_lines.some(p => p.product_id != pline.product_id && p.quantity > 0)) {
                        return;
                    }
                }
            }

            pline.quantity += amount;
        },
        goPreviousStep: function () {
            this.change_step = 1;
        },
        changePassengerNextStep: async function () {
            try {
                if (!this.validatePassengers()) {
                    throw new Error('Product quantity exceeded');
                }
                this.loading = true;
                var cartResult = await this.shoppingCartService.updateProducts(
                    {
                        shopping_cart: this.entity,
                        product_lines: this.product_lines
                    });
                    cartResult.order_id = this.entity.id;
                cartResult = await this.shoppingCartService.calculate(
                {shopping_cart:cartResult}    
                );

                cartResult.contact = this.entity.contact;
                this.$store.commit('shopping_cart_store/update', cartResult)

                this.change_step = 2;
                let newVehicles = [];
                this.product_lines.forEach(p => {
                    if (p.product_type == 'vehicle') {
                        //var aa = JSON.parse(p.data)
                        for (let i = 0; i < p.quantity; i++) {
                            let vehicle = {
                                product_id: p.product_id,
                                model: '',
                                registration_number: ''
                            }
                            if (this.entity.vehicles && this.entity.vehicles.length > 0) {
                                let foundVehicles = this.entity.vehicles.filter(v => v.product_id == p.product_id)
                                if (foundVehicles && foundVehicles[i]) {
                                    vehicle = foundVehicles[i];
                                }
                            }
                            newVehicles.push(vehicle)
                        }
                    }
                })
                this.vehicles = newVehicles;
            } catch (err) {
                console.log(err)
            }
            finally {
                this.loading = false;
            }



        },
        validateVehicles: function () {
            this.vehicle_errors = {}
            this.entity.vehicles.forEach(v => {
                v.model_errors = null;

                v.registration_number_errors = null;
                var result = true
                if (!/(.*[a-z]){3}/i.test(v.model)) {
                    result = false
                }
                if (!v.model || v.model.length < 4) {
                    result = false
                }
                if (!result) {
                    v.model_errors = [this.$t('pages.checkout.error_vehicle_model')]
                }

                var numberResult = true
                if (v.registration_number.length < 2) {
                    numberResult = false
                }
                if (!numberResult) {
                    v.registration_number_errors = [this.$t('pages.checkout.error_vehicle_registration_number')]
                }
                if (!result || !numberResult) {
                    this.vehicle_errors['vehicle_info'] = [this.$t('pages.checkout.error_vehicle_info')]
                }
            })
            //////////////////
            if (Object.keys(this.vehicle_errors).length > 0) {
                return false
            }
            else {
                return true
            }
        },
        validatePassengers: function () {
            this.result_error = '';
            let result = true;
            var foundChange = false;

            this.entity.product_lines.forEach(p => {
                let newpl = this.product_lines.find(np => np.product_id == p.product_id);
                if (newpl.quantity > p.quantity) {
                    this.result_error = this.$t('pages.change.error_passenger_quantity_exceeded')
                    result = false;
                }
                else if (newpl.quantity < p.quantity) {
                    foundChange = true;
                }
            })
            if (result) {
                if (!foundChange) {
                    this.result_error = this.$t('pages.change.error_passenger_quantity_not_changed')
                    result = false;
                }
            }
            return result;
        },

        validateTerm: function () {
            this.result_error = '';
            if (!this.agree_term) {
                this.result_error = this.$t('pages.change.error_agree_term');
                return false;
            }
            return true;
        },
        uuid: function () {
            return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
                return v.toString(16)
            })
        },
        nextStep: async function (gateway) {
            if (this.validateVehicles() && this.validatePassengers() && this.validateTerm()) {
                this.loading = true;
                try {
                    var checkoutResult = await this.orderService.createCheckout(this.entity.id,
                        { ...this.shopping_cart, vehicles: this.vehicles, previous_product_lines: this.entity.product_lines },
                        this.entity.token
                    )
                    let codeChanllenge = this.uuid()
                    this.$store.commit('app_settings/set_code_challenge', codeChanllenge)
                    let payload = {
                        redirect_url: `${window.location.origin}/${this.app_locale}/landing?checkout_token=${checkoutResult.token}`,
                        gateway: gateway,
                        locale: this.locale,
                        user_id: null,
                        unique_token: this.uuid(),
                        code_challenge: codeChanllenge
                    }
                    var initPaymentResult = await this.checkoutService.initPayment(checkoutResult.token, payload)
                    location.href = initPaymentResult.payment_url;
                }
                catch {
                    this.success = false;
                }
                finally {
                    this.loading = false;
                }
            }
        },
        changePassengers: async function () {
            if (this.validateVehicles() && this.validatePassengers() && this.validateTerm()) {
                this.loading = true;
                try {
                    var checkoutResult = await this.orderService.createCheckout(this.entity.id,
                        { ...this.shopping_cart, vehicles: this.vehicles, previous_product_lines: this.entity.product_lines },
                        this.entity.token
                    )
                    let newOrder = await this.checkoutService.complete(checkoutResult.token);
                    this.change_step = 3;
                    this.success = true;
                    this.order_html = await this.orderService.getHtml(newOrder.id, newOrder.template, newOrder.token);
                }
                catch {
                    this.success = false;
                }
                finally {
                    this.loading = false;
                }
            }
        },
    }
}
</script>
